export default "__VITE_ASSET__D$B3Rhoi__"